<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="4">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12">
        <v-btn color="accent" text @click="openModal">
          <v-icon left>mdi-plus</v-icon>Add Record
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="LineNum"
          hide-default-footer
          disable-sort
          :mobile-breakpoint="0"
        >
          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn @click="deleteRow(item)" color="red" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>
      </v-col>

      <v-col cols="12">
        <v-btn
          color="accent"
          v-if="orderItems.length > 0"
          @click="sendData"
          :loading="loader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>

    <!-- start of modal -->
    <v-dialog v-model="dialog" max-width="850px">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title>Outsourced Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" xs="12" md="6">
                <v-text-field
                  name="outsourcedProductName"
                  outlined
                  dense
                  label="Product Name"
                  v-model="record.Name"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedQuantity"
                  outlined
                  dense
                  label="Quantity"
                  v-model="record.Quantity"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedBuyingPrice"
                  outlined
                  dense
                  label="Buying Price"
                  v-model="record.BuyingPrice"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedSellingPrice"
                  outlined
                  dense
                  label="Selling Price"
                  v-model="record.SellingPrice"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedGrossProfit"
                  outlined
                  dense
                  filled
                  readonly
                  label="Gross Profit"
                  v-model="GrossProfit"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedCommission"
                  outlined
                  dense
                  label="Commission"
                  v-model="record.Commission"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-text-field
                  name="outsourcedNetProfit"
                  outlined
                  dense
                  filled
                  readonly
                  label="Net profit"
                  v-model="NetProfit"
                ></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="3">
                <v-btn color="accent" @click="addItem">
                  <v-icon left>mdi-plus</v-icon> Add
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of  modal-->
  </v-form>
</template>

<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    pageItems: 100,
    dialog: false,
    orderItems: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Product", value: "Name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "SellingPrice" },
      { text: "Gross Profit", value: "GrossProfit" },
      { text: "Commission", value: "Commission" },
      { text: "Net Profit", value: "NetProfit" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    NetProfit() {
      let data = this.record;
      let Commission = 0;
      if (data.Commission) {
        Commission = parseFloat(data.Commission);
      }

      let Profit = 0;
      let GrossProfit = 0;
      GrossProfit = this.GrossProfit;
      Profit = GrossProfit - Commission;
      return Profit;
    },
    GrossProfit() {
      let Profit = 0;
      let data = this.record;
      let BuyingPrice = 0;
      let SellingPrice = 0;
      let Quantity = 0;
      if (data.BuyingPrice) {
        BuyingPrice = parseFloat(data.BuyingPrice);
      }
      if (data.SellingPrice) {
        SellingPrice = parseFloat(data.SellingPrice);
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      }

      Profit = Quantity * (SellingPrice - BuyingPrice);
      return Profit;
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    openModal() {
      this.dialog = true;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
    },
    addItem() {
      let data = this.record;
      data.GrossProfit = this.GrossProfit;
      data.NetProfit = this.NetProfit;
      data.LineNum = new Date().getTime();

      const initArray = [];
      initArray.push(data);
      this.orderItems = [...this.orderItems, ...initArray];
      this.record = {};

      this.dialog = false;
    },
    setDate(date) {
      this.date = date;
    },
    sendData() {
      this.loader = true;
      const data = {
        date: this.date,
        rows: this.orderItems,
      };
      this.loader = true;
      this.$emit("data", data);
    },
  },
};
</script>